import { bindLinks, initApp, requestIdleCallbackFunction, unbindLinks } from './load-functions';

// VITE_ASSETS_ABSOLUTE_PATH is injected at build time from Bitbucket Deployment
// variables, so each environment's bundle has its own absolute URL baked in.
// Falls back to '/' for local dev where the var is not set.
const ABSOLUTE_PATH = import.meta.env.VITE_ASSETS_ABSOLUTE_PATH || '/';

window.b2b = {
  ...window.b2b,
  __get_asset_location: (filename) => `${ABSOLUTE_PATH}${filename}`,
};

(async function bootstrap() {
  // check if the accessed url contains a hashtag
  if (window.location.hash.startsWith('#/')) {
    initApp();
  } else {
    // load the app when the browser is free
    requestIdleCallbackFunction(initApp);
    // and bind links to load the app
    bindLinks();
    window.addEventListener('beforeunload', unbindLinks);
    // and observe global flag to simulate click
    window.b2b.initializationEnvironment.isInitListener = () => {
      unbindLinks();
      setTimeout(() => window.b2b.initializationEnvironment.clickedLinkElement?.click(), 0);
    };
  }
})();
